export default "__VITE_ASSET__0106af34__"